import { createContext, useContext } from 'react';

import { IDetailedUser } from '~/@store/users';

export const UserDetailContext = createContext<IDetailedUser>({} as IDetailedUser);

export const useUserDetailContext = () => useContext(UserDetailContext);
